import { useCallback } from "react";
import { ThemeType, useTheme } from "@/mds/themes/theme-context";

/**
 * Encapsulates the shared theme selection logic used by both the settings
 * appearance dropdown and the sidebar theme submenu.
 */
export function useThemeSelection() {
  const { themePreference, setTheme } = useTheme();

  const selectTheme = useCallback(
    (id: string) => {
      setTheme(id as ThemeType);
      return true;
    },
    [setTheme]
  );

  return { themePreference, selectTheme };
}
